export const PROFISSIONAL_SELECT_PLACEHOLDER = "Selecione o profissional";
export const PROFISSIONAL_SELECT_FILTER_PLACEHOLDER = "Buscar por nome ou e-mail";
export const PROFISSIONAL_SELECT_EMPTY = "Nenhum profissional encontrado.";
export const PROFISSIONAL_SELECT_LOADING = "Carregando profissionais...";

/** Área rolável do menu: 198,5px (Figma 9129:353328). */
export const PROFISSIONAL_SELECT_ALTURA_LISTA = "198.5px";
